<template>
  <!-- 当前商品辅料标识及悬浮详情 -->
  <el-popover
    v-if="material && material_id > 0"
    placement="right-start"
    trigger="hover"
    width="320"
  >
    <!-- 悬浮层展示辅料主档信息 -->
    <div class="material-popover">
      <div class="material-popover-id">辅料ID：{{ material.id || material_id }}</div>
      <div class="material-popover-body">
        <el-image class="material-popover-image" :src="material.main_image" fit="cover" />
        <div class="material-popover-info">
          <div>{{ material.name_trans || material.name }}</div>
          <div class="material-popover-type">
            {{ material.type && (material.type.name_trans || material.type.name) }}
          </div>
          <div :class="Number(material.material_stock_num || 0) > 0 ? 'stock-ok' : 'stock-error'">
            {{ Number(material.material_stock_num || 0) > 0 ? '库存充足' : '库存不足' }}
          </div>
          <div>库存数量：{{ material.material_stock_num || 0 }}</div>
        </div>
      </div>
    </div>
    <!-- 标识固定在商品行左上角 -->
    <span slot="reference" class="material-mark">辅料</span>
  </el-popover>
</template>

<script>
export default {
  // 配送单预览页的当前商品辅料标识组件
  name: 'DeliveryPreviewMaterialMark',
  props: {
    material: { type: Object, default: null },
    material_id: { type: [Number, String], default: 0 },
  },
}
</script>

<style lang="scss" scoped>
// 辅料标识固定在商品区域左上角
.material-mark {
  position: absolute;
  top: 4px;
  left: 4px;
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  background: #eaf2ff;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
}

// 辅料悬浮详情布局
.material-popover-id {
  margin-bottom: 10px;
  color: #303133;
  font-size: 14px;
}

.material-popover-body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.material-popover-image {
  flex: 0 0 96px;
  width: 96px;
  height: 96px;
  background: #f2f2f2;
}

.material-popover-info {
  min-width: 0;
  color: #606266;
  font-size: 14px;
  line-height: 22px;
}

.material-popover-type {
  display: inline-block;
  padding: 0 6px;
  border-radius: 3px;
  background: #eaf2ff;
  color: #409eff;
}

.stock-ok {
  color: #67c23a;
}

.stock-error {
  color: #f56c6c;
}
</style>
